import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */
import { useEntityBlockEditor, useEntityProp, useEntityRecord } from '@wordpress/core-data';
import { Placeholder, Spinner, TextControl, PanelBody } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useInnerBlocksProps, __experimentalRecursionProvider as RecursionProvider, __experimentalUseHasRecursion as useHasRecursion, InnerBlocks, InspectorControls, useBlockProps, Warning } from '@wordpress/block-editor';
export default function ReusableBlockEdit({
  attributes: {
    ref
  }
}) {
  const hasAlreadyRendered = useHasRecursion(ref);
  const {
    record,
    hasResolved
  } = useEntityRecord('postType', 'wp_block', ref);
  const isMissing = hasResolved && !record;
  const [blocks, onInput, onChange] = useEntityBlockEditor('postType', 'wp_block', {
    id: ref
  });
  const [title, setTitle] = useEntityProp('postType', 'wp_block', 'title', ref);
  const blockProps = useBlockProps({
    className: 'block-library-block__reusable-block-container'
  });
  const innerBlocksProps = useInnerBlocksProps(blockProps, {
    value: blocks,
    onInput,
    onChange,
    renderAppender: blocks?.length ? undefined : InnerBlocks.ButtonBlockAppender
  });
  if (hasAlreadyRendered) {
    return createElement("div", {
      ...blockProps
    }, createElement(Warning, null, __('Block cannot be rendered inside itself.')));
  }
  if (isMissing) {
    return createElement("div", {
      ...blockProps
    }, createElement(Warning, null, __('Block has been deleted or is unavailable.')));
  }
  if (!hasResolved) {
    return createElement("div", {
      ...blockProps
    }, createElement(Placeholder, null, createElement(Spinner, null)));
  }
  return createElement(RecursionProvider, {
    uniqueId: ref
  }, createElement(InspectorControls, null, createElement(PanelBody, null, createElement(TextControl, {
    __nextHasNoMarginBottom: true,
    label: __('Name'),
    value: title,
    onChange: setTitle
  }))), createElement("div", {
    ...innerBlocksProps
  }));
}
//# sourceMappingURL=edit.js.map